module.exports = __webpack_public_path__ + "img/warning-message-icon.156e410b.svg";